// test1638
(1638 && 0);
